import { ManifestClientService } from '../services/manifest-client.service';
import { TranslationService } from '../services/translations-service/translation.service';
import { installAppletHost } from '../services/applet-host/install';
import { IdentityClientService } from '../services/Identity-service/identity-client.service';
import { AnalyticsService } from '../services/analytics-service/analytics.service';
import { FeatureToggleService } from '../services/feature-toggle.service';
import { saveUser } from '../store/setter.store';
import { AuthService } from '../services/auth-service/auth.service';

export default async () => {
  if (window.AppChrome && window.AppChrome.ready === true) {
    if (window.appContainerPlaceholder) {
      window.appContainerPlaceholder.remove();
    }
  } else {
    window.addEventListener('app-chrome-ready', () => {
      if (window.appContainerPlaceholder) {
        window.appContainerPlaceholder.remove();
      }
    });
  }

  window.addEventListener('app-chrome-location-change-internal-app', (event: CustomEvent) => {
    event.preventDefault();
  });

  try {
    IdentityClientService.init();
    ManifestClientService.init();
    ManifestClientService.getCurrentUser().then((user) => {
      TranslationService.setLanguage(user.language);
      saveUser({ timezone: user.timezone, language: user.language });
    })
  } catch {
    AuthService.logout();
  }

  AnalyticsService.trackIdentity();

  await installAppletHost();
  await FeatureToggleService.getTreatments();
};
